import spinRoute from '../../router/spinRoute.js';

//标签 所有页面
export default () => [
    {
        path: '/label/queryContainer',
        component: () => spinRoute.require(import('./queryContainer.vue')),
        meta: { title: '标签', noGoBack: true },
        children: [
            {
                path: '/label/search',
                component: () => spinRoute.require(import('./pages/search.vue')),
                meta: { title: '', hideBarFoot: true, keepAlive: true }, //搜索
            },
            {
                path: '/label/employeeList',
                component: () => spinRoute.require(import('./pages/employeeList.vue')),
                meta: { title: '', hideBarFoot: true }, //员工列表页
            },
            {
                path: '/label/myLab',
                component: () => spinRoute.require(import('./pages/myLab.vue')),
                meta: { title: '', hideBarFoot: true }, //我的标签
            },
            {
                path: '/label/myPro',
                component: () => spinRoute.require(import('./pages/myPro.vue')),
                meta: { title: '', hideBarFoot: true }, //我的信息
            },
            {
                path: '/label/mineDetail',
                component: () => spinRoute.require(import('./pages/empDetail.vue')),
                meta: { title: '', hideBarFoot: true }, //个人画像
            },
            {
                path: '/label/myProEdit',
                component: () => spinRoute.require(import('./pages/myProEdit.vue')),
                meta: { title: '', hideBarFoot: true },
            },
            {
                path: '/label/searchAdvance',
                component: () => spinRoute.require(import('./pages/searchAdvance.vue')),
                meta: { title: '标签管理', hideBarFoot: true },
            },
            {
                path: '/label/empDetail',
                component: () => spinRoute.require(import('./pages/empDetail.vue')),
                meta: { title: '员工画像', hideBarFoot: true },
            },
        ]
    },
]
